module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "propose-unapproved-list"
  }, [_c('app-header', {
    staticClass: "header"
  }), _c('ul', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v(_vm._s(_vm.$t('Home')))])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/proposes"
    }
  }, [_vm._v(_vm._s(_vm.$t('Propose')))])], 1), _c('li', {
    staticClass: "active"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Propose Unapproved List')))])])]), _c('h2', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('Propose Unapproved List')))]), _c('div', [((_vm.proposes != null && _vm.proposes.length > 0) && _vm.searchCallbackFlag) ? _c('div', [_c('div', {
    staticClass: "row margin-top text-right"
  }, [_c('h4', [_vm._v("合計件数 " + _vm._s(_vm.proposeTotalCount) + " 件")])]), _c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-condensed"
  }, [_vm._m(0), _c('tbody', _vm._l((_vm.proposes), function(propose, index) {
    return _c('tr', [_c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s(propose.attributes['contribution-at-format']))]), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s(propose.attributes['shop-name']))]), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s(propose.attributes['user-name']) + " " + _vm._s(propose.attributes['user-firstname']))]), _c('td', [_c('a', {
      on: {
        "click": function($event) {
          _vm.goProposeDetail(propose.id)
        }
      }
    }, [_vm._v(" " + _vm._s(propose.attributes['propose-title']))])])])
  }))])])]), (_vm.nextPage) ? _c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "col-xs-12 text-center"
  }, [_c('button', {
    staticClass: "btn btn-default next-page-search-btn",
    on: {
      "click": function($event) {
        _vm.search(true)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-down"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('Read More')))])])])]) : _vm._e()]) : _vm._e(), ((_vm.proposes == null || _vm.proposes.length <= 0) && _vm.searchCallbackFlag) ? _c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "alert alert-warning"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('No Data')))])])])]) : _vm._e()])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "info"
  }, [_c('th', {
    staticClass: "col-sm-3 hidden-xs"
  }, [_vm._v("投稿日時")]), _c('th', {
    staticClass: "col-sm-2 hidden-xs"
  }, [_vm._v("店舗名")]), _c('th', {
    staticClass: "col-sm-2 hidden-xs"
  }, [_vm._v("社員名")]), _c('th', {
    staticClass: "col-sm-6"
  }, [_vm._v("提案タイトル")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-17f1b8f4!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./src/components/templates/propose-unapproved-list.pug
// module id = 772
// module chunks = 1